import React, { useState } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import { cn } from "../../../utils/constants/cn";
import SuggestionInput from "../SuggestionInput/main";

interface Props {
  onSearch: (query: any) => void;
  onClear: () => void;
  width?: string;
  suggestionInputEnable?: {
    setActiveValue:(value:string) =>void
    activeValue: any;
    enable: boolean;
    suggestions: any[];
    onSuggestionSelect: (suggestion: number) => void;
    loading: boolean;
  };
}

const SearchBar: React.FC<Props> = ({
  onSearch,
  onClear,
  width,
  suggestionInputEnable,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleApply = () => {
    onSearch(searchTerm);
  //  console.log("Searching for:", searchTerm);
  };

  const handleClear = () => {
    onClear();
    setSearchTerm("");
    if(!suggestionInputEnable?.enable){
      onSearch("");
    }
  };

  return (
    <div
      className={cn(
        "p-1 border border-gray-300 rounded-lg bg-white shadow-sm w-full max-w-2xl transition-all duration-100  mx-auto",
        width
      )}
    >
      <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4">
        {suggestionInputEnable && suggestionInputEnable.enable ? (
          <SuggestionInput
            setActiveValue={((value:string) =>suggestionInputEnable.setActiveValue(value))}
            activeValue={suggestionInputEnable.activeValue}
            loading={suggestionInputEnable.loading}
            suggestions={suggestionInputEnable.suggestions}
            setActiveIndex={((value:number) =>{
              suggestionInputEnable.onSuggestionSelect(value)
            })}
          />
        ) : (
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="Search..."
            className="w-full sm:flex-1 p-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary"
          />
        )}

        <div className="grid grid-cols-1 gap-3 w-full sm:w-auto">
          {/* <button
            onClick={handleApply}
            className="flex items-center justify-center px-4 py-1 bg-primary text-white rounded-lg hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <FaSearch className="mr-2" />
            Search
          </button> */}
          <button
            onClick={handleClear}
            className="flex items-center justify-center px-4 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            <FaTimes className="mr-2" />
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
